import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';

import CommonModal from '../../components/common-modal/CommonModal';
import { changeAdminPassword } from '../../redux/user-management/userManagementActions';
import validate from '../../utils/validate';
import ChangePasswordForm from './ChangePasswordForm';
import { changePasswordYupValidation } from './validation';

const ChangePasswordModal = ({ isOpen, onClose, id }) => {
  const dispatch = useDispatch();
  const changePasswordInitialValues = {
    password: '',
    repeatPassword: '',
  };

  const handleChangePassword = useCallback(
    ({ password }) => {
      dispatch(changeAdminPassword({ id, password }));
      onClose();
    },
    [dispatch, id, onClose],
  );

  return (
    <CommonModal isOpen={isOpen} onClose={onClose}>
      <Form
        initialValues={changePasswordInitialValues}
        onSubmit={handleChangePassword}
        validate={(values) => validate(values, changePasswordYupValidation())}
        subscription={{ submitting: true, pristine: true }}
        render={({ handleSubmit }) => <ChangePasswordForm handleSubmit={handleSubmit} />}
      />
    </CommonModal>
  );
};

export default memo(ChangePasswordModal);
